export default {
  ownedPlaces: [],
  places: [],
  place: undefined,
  totalSpots: 0,
  availableSpots: 0,
  sessions: [],
  controllers: [],
  loadingControllers: false,
  refreshingControllers: false,
  openingOrClosingGate: false,
  controllerLogs: [],
  selectedController: undefined,
  controllerFirmwareList: []
}
